import { render, staticRenderFns } from "./ProposalEdit.vue?vue&type=template&id=2d1f9b86&"
import script from "./ProposalEdit.vue?vue&type=script&lang=js&"
export * from "./ProposalEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProposalEdit.vue?vue&type=style&index=0&id=2d1f9b86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports